function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "loading");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-activities-/-bunkering",
  transform: "translate(-1.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M22,15.983553 L19.82,15.983553 C19.9364225,15.6632557 19.9972954,15.3254703 20,14.9847278 L20,9.99060172 C20,8.33569392 18.6568542,6.99412608 17,6.99412608 L11,6.99412608 C9.34314575,6.99412608 8,8.33569392 8,9.99060172 L8,14.9847278 C8.00270456,15.3254703 8.06357745,15.6632557 8.18,15.983553 L7,15.983553 C6.44771525,15.983553 6,15.5363637 6,14.9847278 L6,4.99647565 C6,3.34156784 4.65685425,2 3,2 L2,2 C1.44771525,2 1,2.44718928 1,2.99882522 C1,3.55046115 1.44771525,3.99765043 2,3.99765043 L3,3.99765043 C3.55228475,3.99765043 4,4.44483971 4,4.99647565 L4,14.9847278 C4.00757857,16.3333366 4.91621383,17.5107219 6.22,17.8613444 C5.71356938,19.0988297 6.08912443,20.5217032 7.14053012,21.3489767 C8.19193582,22.1762502 9.66481725,22.2077749 10.7507378,21.4262474 C11.8366583,20.64472 12.2728927,19.2392215 11.82,17.9812034 L15.18,17.9812034 C14.7280155,19.225043 15.1463641,20.6177417 16.2092461,21.4076036 C17.272128,22.1974655 18.727872,22.1974655 19.7907539,21.4076036 C20.8536359,20.6177417 21.2719845,19.225043 20.82,17.9812034 L22,17.9812034 C22.5522847,17.9812034 23,17.5340142 23,16.9823782 C23,16.4307423 22.5522847,15.983553 22,15.983553 L22,15.983553 Z M9,19.9788539 C8.44771525,19.9788539 8,19.5316646 8,18.9800287 C8,18.4283927 8.44771525,17.9812034 9,17.9812034 C9.55228475,17.9812034 10,18.4283927 10,18.9800287 C10,19.5316646 9.55228475,19.9788539 9,19.9788539 Z M11,15.983553 C10.4477153,15.983553 10,15.5363637 10,14.9847278 L10,9.99060172 C10,9.43896579 10.4477153,8.99177651 11,8.99177651 L17,8.99177651 C17.5522847,8.99177651 18,9.43896579 18,9.99060172 L18,14.9847278 C18,15.5363637 17.5522847,15.983553 17,15.983553 L11,15.983553 Z M18,19.9788539 C17.4477153,19.9788539 17,19.5316646 17,18.9800287 C17,18.4283927 17.4477153,17.9812034 18,17.9812034 C18.5522847,17.9812034 19,18.4283927 19,18.9800287 C19,19.5316646 18.5522847,19.9788539 18,19.9788539 Z",
  id: "loading"
})));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.56c532a7.svg";
export { ForwardRef as ReactComponent };